import PropTypes from 'prop-types'

const ExpandableIcon = ({ title }: any) => (
  <svg width="191px" height="191px" viewBox="0 0 191 191">
    <title>{title}</title>
    <g id="layout-options-explorations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="tooltip-future" transform="translate(-290.000000, -122.000000)">
        <g id="Expandable-Image" transform="translate(290.000000, 96.000000)">
          <g id="visual_expandable" transform="translate(0.000000, 26.000000)">
            <rect id="Rectangle" fill="#D8D8D8" x="0" y="0" width="191" height="191"></rect>
            <rect id="Rectangle" fill="#9F9F9F" x="0" y="16" width="14" height="175"></rect>
            <rect id="Rectangle-Copy" fill="#806BF2" x="76" y="16" width="109" height="175"></rect>
            <rect id="Rectangle-Copy-2" fill="#828282" x="14" y="16" width="62" height="175"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="20" y="4" width="105" height="6" rx="1.5"></rect>
            <circle id="Oval-Copy" fill="#8D8D8D" cx="5" cy="7" r="3"></circle>
            <circle id="Oval-Copy-2" fill="#8D8D8D" cx="13" cy="7" r="3"></circle>
            <polyline id="Line-2" stroke="#FFFFFF" strokeLinecap="square" points="83 63 77 69.0775002 83 75"></polyline>
            <polyline
              id="Line-2-Copy"
              stroke="#FFFFFF"
              strokeLinecap="square"
              points="177 63 182 69.0821592 177 75"
            ></polyline>
            <line
              x1="182.005952"
              y1="69"
              x2="81.5"
              y2="68.5"
              id="Line-3"
              stroke="#FFFFFF"
              strokeLinecap="square"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
ExpandableIcon.displayName = 'ExpandableIcon'

ExpandableIcon.propTypes = {
  title: PropTypes.string
}

ExpandableIcon.defaultProps = {
  title: 'Expandable'
}
export default ExpandableIcon
